import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { AppSelector } from 'store';

export const useAppSelector: TypedUseSelectorHook<AppSelector> = useSelector;
